import React from 'react'

export default function Footer() {
  return (
    <div class="container">
      <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <div class="d-flex align-items-center">
            <a href="www.dashowl.co.uk" class="text-decoration-none mb-md-0 text-muted">DashOwl</a> 
        </div>
        <ul class="nav justify-content-end list-unstyled d-flex">
          <li class="ms-3"><a class="text-muted text-decoration-none" href="https://www.buymeacoffee.com/alanjsfleming">Buy Me a Coffee</a></li>
        </ul>
  </footer>
</div>
  )
}